<template>
  <div>
    <Button
      hasOutline
      text="view"
      type="secondary"
      @click="createModal"
    />
  </div>
</template>

<script>
import { Button } from '@jumpcloud/ui-components';
import { VppSoftwareAppStatusConsts } from 'client/util/Constants';
import ModalEventBus from 'components/Modal/ModalEventBus';
import SystemMixin from 'client/store/mixins/SystemMixin';
import ViewSoftwareAppStatusButtonConfirmationModal from 'client/components/Modal/ViewSoftwareAppStatusButtonConfirmationModal.vue';
import moment from 'moment';

export default {
  name: 'ViewSoftwareAppStatusButton',

  components: {
    Button,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    details() {
      return this.item.details || 'N/A';
    },
    isIOS() {
      return SystemMixin.isIOS(this.system);
    },
    isMacOS() {
      return SystemMixin.isMacOS(this.system);
    },

    status() {
      return this.item.state ? this.item.state.replace('_', ' ') : '';
    },

    system() {
      return this.item.device || this.item;
    },
    updatedVersion() {
      return this.item.version ? this.item.version : 'N/A';
    },
    vppStatus() {
      const { state } = this.item;
      const fullStatus = state || '';
      return VppSoftwareAppStatusConsts[fullStatus].value ? VppSoftwareAppStatusConsts[fullStatus].value : '';
    },
  },

  methods: {
    createModal() {
      const {
        code, timestamp, device,
      } = this.item;

      ModalEventBus.open({
        component: ViewSoftwareAppStatusButtonConfirmationModal,
        componentProps: {
          headerText: `${device.displayName} results log`,
          code,
          formattedTimestamp: moment.utc(timestamp).format('MMMM D, YYYY hh:mm A'),
          status: (this.isMacOS || this.isIOS) ? this.vppStatus : this.status,
          details: this.details,
          updatedVersion: this.updatedVersion,
        },
      });
    },
  },
};
</script>
